import { render, staticRenderFns } from "./scoreHamburger.vue?vue&type=template&id=7079c4a5"
import script from "./scoreHamburger.vue?vue&type=script&lang=js"
export * from "./scoreHamburger.vue?vue&type=script&lang=js"
import style0 from "./scoreHamburger.vue?vue&type=style&index=0&id=7079c4a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports